export default "__VITE_ASSET__47966ba4__"